<template>
  <div flat class="h-100 w-100">
    <b-row no-gutters class="pa-3 h-100 justify-content-between">
      <b-col cols="4" class="h-100">
        <b-row no-gutters align-v="center" class="justify-content-between">
          <b-col cols="4" class="pl-3">{{ t.t(dictEnum.LBL_Status) }}</b-col>
          <b-col cols="4">
            <b-form-select v-model="paymentStatus" @change="getPaymentList()">
              <option value="All" selected="selected">
                {{ t.t(dictEnum.LBL_SelectAll) }}
              </option>
              <option
                v-for="(status, statusIndex) in paymentStatusList"
                :key="statusIndex"
                :value="status.id"
              >
                {{ status.value }}
              </option>
            </b-form-select>
          </b-col>
          <b-col cols="3" class="text-right">
            <!-- <font-awesome-icon
              icon="plus"
              style="cursor:pointer"
              v-if="hasRight(Settings.Permission.Change)"
              @click="showAddSpecPayment()"
            />
            <font-awesome-icon
              icon="edit"
              style="cursor:pointer"
              v-if="hasRight(Settings.Permission.Change)"
              @click="editSpecialPayment"
            />
            <font-awesome-icon
              icon="trash"
              style="cursor:pointer"
              v-if="hasRight(Settings.Permission.Delete)"
              @click="deleteSpecialPayment"
            /> -->
          </b-col>
        </b-row>
        <b-row no-gutters class="h-90 pt-3">
          <div class="tab-content bg-white w-100">
            <div class="tab-pane active table-responsive color-table">
              <b-table
                :items="specPayList"
                :fields="specPayField"
                :current-page="currentPage"
                :per-page="perPage"
                :tbody-tr-class="rowClass"
                @row-clicked="OnSpecialPaymentSelect"
              >
                <template #head(DateVal)>
                  <div class="text-center">
                    {{ t.t(dictEnum.LBL_Date) }}
                  </div>
                </template>
                <template #head(TotAmt)>
                  <div class="text-right">
                    {{ t.t(dictEnum.LBL_Amount) }}
                  </div>
                </template>
                <template #cell(DateVal)="data">
                  <div class="text-center">
                    {{ data.item.DateVal | moment(Settings.DateTime.yyyymmdd) }}
                  </div>
                </template>
                <template #cell(TotAmt)="data">
                  <div class="text-right">
                    {{ data.item.TotAmt | toFixedDecimal }}
                  </div>
                </template>
                <template #cell(Status)="data">
                  {{ StatusName(data.item.Status) }}
                </template>
              </b-table>
            </div>
          </div>
        </b-row>
        <b-row no-gutters class="pt-3" v-if="specPayList.length > 0">
          <b-col cols="2">
            <b-pagination
              first-number
              last-number
              limit="10"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="specPayList.length"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="8" class="h-100 pl-5">
        <b-row no-gutters align-v="center">
          <b-col cols="1">{{ t.t(dictEnum.LBL_DatePay) }}</b-col>
          <b-col cols="2" class="pr-3">
            <date-picker
              id="dpRoster"
              v-model="selectedItem.DateVal"
              :lang="lang"
              type="date"
              format="YYYY-MM-DD"
              :disabled="disabledMode"
              v-bind:clearable="false"
            ></date-picker>
          </b-col>
          <b-col cols="1" class="pr-2">
            {{ t.t(dictEnum.LBL_Particular) }}
          </b-col>
          <b-col cols="4">
            <b-form-input
              v-model="selectedItem.PayDesc"
              :disabled="disabledMode"
            ></b-form-input>
          </b-col>
          <b-col cols="1" class="pl-2 pr-2">
            {{ TotalActual() | toFixedDecimal }}
          </b-col>
          <b-col cols="3" class="d-flex justify-content-end">
            <button
              v-if="
                hasRight(Settings.Permission.Change) &&
                  selectedItem.Status == Settings.PayrollStatus.Approving
              "
              class="approve btn btn-primary waves-effect waves-light mr-2"
              @click="ApprovelItems()"
            >
              {{ t.t(dictEnum.LBL_Approve) }}
            </button>
            <button
              v-if="
                hasRight(Settings.Permission.Change) &&
                  selectedItem.Status == Settings.PayrollStatus.Approving
              "
              class="approve btn btn-danger waves-effect waves-light"
              @click="RejectlItems()"
            >
              {{ t.t(dictEnum.LBL_Reject) }}
            </button>
            <button
              v-if="
                hasRight(Settings.Permission.Print) &&
                  selectedItem.Status == Settings.PayrollStatus.Approved
              "
              @click="clickExport()"
              class="approve btn btn-primary waves-effect waves-light mr-2"
            >
              {{ t.t(dictEnum.BTN_Export) }}
            </button>
            <button
              v-if="
                hasRight(Settings.Permission.Print) &&
                  selectedItem.Status == Settings.PayrollStatus.Approved
              "
              @click="clickPrint()"
              class="approve btn btn-info waves-effect waves-light mr-2"
            >
              {{ t.t(dictEnum.LBL_Print) }}
            </button>
          </b-col>
        </b-row>
        <b-row
          no-gutters
          class="w-100 btn-message mt-3"
          style="min-height:40px"
        >
          <b-col cols="3">
            <b-btn
              pill
              v-if="messageList.length > 0"
              class="ma-1 ellipsis"
              @click="showPaymentMessage"
            >
              <font-awesome-icon icon="question-circle" />
              {{
                messageList[0].Notes
                  ? messageList[0].Notes
                  : t.t(dictEnum.LBL_Msg)
              }}
            </b-btn>
          </b-col>
          <b-col cols="4" class="d-flex align-center text-white">
            <div class="pr-2">{{ t.t(dictEnum.LBL_IncType) }}:</div>
            <div>{{ selectedItem.IncTypeCode }}</div>
          </b-col>
          <b-col cols="4" class="d-flex align-center text-white">
            <div class="pr-2">{{ t.t(dictEnum.LBL_IncSubType) }}:</div>
            <div>{{ selectedItem.IncSubType }}</div>
          </b-col>
        </b-row>
        <div class="h-90 w-100" style="overflow-y: auto;">
          <div
            class="paymentByDept w-100"
            v-for="(DeptItem, DeptItemIndex) in specPaymentDetail"
            :key="DeptItemIndex"
          >
            <b-row no-gutters class="paymentByDept_head">
              <b-col cols="4">
                <div>
                  {{ DeptItem.Dept }} ({{ Actual(DeptItem) | toFixedDecimal }})
                </div>
                <span class="bdr bg-image-rainbow"></span>
              </b-col>
            </b-row>
            <div no-gutters class="w-100" style="overflow-x:auto">
              <table class="paymentByDept_table w-100">
                <thead>
                  <tr>
                    <th style="width:20%">
                      {{ t.t(dictEnum.LBL_StaffID) }}
                    </th>
                    <th style="width:20%">
                      {{ t.t(dictEnum.LBL_Name) }}
                    </th>
                    <th style="width:20%" class="text-center">
                      {{ t.t(dictEnum.LBL_DateJoin) }}
                    </th>
                    <th style="width:20%">
                      {{ t.t(dictEnum.LBL_StaffType) }}
                    </th>
                    <th style="width:20%" class="text-right">
                      {{ t.t(dictEnum.LBL_Amount) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tableItem, ItemIndex) in DeptItem.Details"
                    :key="ItemIndex"
                    @click="selectedAppr(tableItem)"
                    @contextmenu.prevent="showOnlyApp(tableItem)"
                    :class="{
                      'selected-tr':
                        selectedList.map(x => x.Id).indexOf(tableItem.Id) != -1,
                      'approve-tr':
                        tableItem.Status == Settings.PayrollStatus.Approved,
                      'reject-tr':
                        tableItem.Status == Settings.PayrollStatus.Rejected
                    }"
                  >
                    <td>{{ tableItem.Id }}</td>
                    <td>{{ tableItem.Name }}</td>
                    <td class="text-center">
                      {{
                        tableItem.DateJoin | moment(Settings.DateTime.yyyymmdd)
                      }}
                    </td>
                    <td>{{ tableItem.Type }}</td>
                    <td class="text-right">
                      <div v-if="disabledMode">
                        {{ tableItem.Total | toFixedDecimal }}
                      </div>
                      <b-form-input
                        v-else
                        danse
                        v-model="tableItem.Total"
                      ></b-form-input>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-modal
      id="SpecPaymentShow"
      :title="t.t(dictEnum.LBL_SpecialPayment)"
      @ok="addSpecialPayment()"
    >
      <b-row no-gutters class="pl-3 pt-3 pr-3">
        <b-col cols="4">{{ t.t(dictEnum.LBL_Month) }}</b-col>
        <b-col cols="8">
          <date-picker
            id="dpRoster"
            v-model="datePay"
            :lang="lang"
            type="date"
            format="YYYY-MM-DD"
            v-bind:clearable="false"
          ></date-picker>
        </b-col>
      </b-row>
      <b-row no-gutters class="pl-3 pt-3 pr-3">
        <b-col cols="4">{{ t.t(dictEnum.LBL_IncType) }}</b-col>
        <b-col cols="8">
          <b-form-select
            v-model="selectedIncType"
            @change="changeIncType()"
            value-field="IncSubType"
          >
            <option v-for="(incT, incTindex) in IncTypeList" :key="incTindex">
              {{ incT.IncTypeDesc }}
            </option>
          </b-form-select>
        </b-col>
      </b-row>
      <b-row no-gutters class="pl-3 pt-3 pr-3">
        <b-col cols="4">{{ t.t(dictEnum.LBL_IncSubType) }}</b-col>
        <b-col cols="8">
          <b-form-select v-model="selectedIncSubType" value-field="IncSubType">
            <option
              v-for="(incT, incTindex) in incTypeList.filter(
                x => x.IncTypeDesc == selectedIncType
              )"
              :key="incTindex"
            >
              {{ incT.IncSubType }}
            </option>
          </b-form-select>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="messageShow"
      :title="t.t(dictEnum.LBL_Msg)"
      :ok-title="t.t(dictEnum.BTN_OK)"
      ok-only
      size="lg"
    >
      <b-row no-gutters>
        <b-form-textarea
          class="ml-2 mr-2 mb-3"
          readonly
          v-model="selectedMsg.Notes"
        ></b-form-textarea>
      </b-row>
      <b-row no-gutters>
        <div class="pl-3 pr-3 w-100">
          <table class="w-100 popupTable">
            <tr class="head">
              <th>{{ t.t(dictEnum.MENU_Employees) }}</th>
              <th style="width: 45%">{{ t.t(dictEnum.LBL_Msg) }}</th>
              <th>{{ t.t(dictEnum.LBL_Approval) }}</th>
              <th>{{ t.t(dictEnum.LBL_Date) }}</th>
            </tr>
            <tr
              v-for="(msg, msgIndex) in messageList"
              :key="msgIndex"
              @click="clickMsg(msg)"
            >
              <td>{{ msg.StfID }} {{ msg.StfName }}</td>
              <td class="ellipsis">{{ msg.Notes }}</td>
              <td>
                <div v-if="msg.Aprv">
                  <img
                    width="20px"
                    src="../../../../../static/images/green tick.png"
                  />
                </div>
                <div v-else>
                  <img
                    width="20px"
                    src="../../../../../static/images/red cancel.png"
                  />
                </div>
              </td>
              <td>
                {{ msg.AddBy }} @
                {{ msg.DateAdd | moment(Settings.DateTime.yyyymmddhhmm) }}
              </td>
            </tr>
          </table>
        </div>
      </b-row>
    </b-modal>
    <b-modal id="onlyApproval" :title="`${selectedDtl.Id} ${selectedDtl.Name}`">
      <template #modal-footer="{ hide }">
        <b-button size="sm" variant="outline-secondary" @click="hide()">
          {{ t.t(dictEnum.BTN_Cancel) }}
        </b-button>
        <b-button size="sm" variant="danger" @click="ApproveOrReject(false)">
          {{ t.t(dictEnum.LBL_Reject) }}
        </b-button>
      </template>

      <b-row no-gutters class="pl-3 pr-3">
        <b-form-textarea
          v-model="selectedDtl.Msg"
          :placeholder="t.t(dictEnum.CFM_Reject)"
          rows="8"
        ></b-form-textarea>
      </b-row>
    </b-modal>
    <b-modal
      id="ApprovalORRejectModalList"
      :title="
        ApproveORReject ? t.t(dictEnum.LBL_Approval) : t.t(dictEnum.LBL_Reject)
      "
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      :ok-title="t.t(dictEnum.BTN_Confirm)"
      @ok="ApprOnlyDtl"
    >
      <b-row no-gutters class="pl-2 pr-2" v-if="selectedList.length == 0">
        {{ selectedItem.DateVal | moment(Settings.DateTime.yyyymmdd) }}
      </b-row>
      <b-row no-gutters class="pl-2 pr-2">
        <b-form-textarea
          outlined
          v-model="selectedDtl.Msg"
          rows="8"
        ></b-form-textarea>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import Settings from "../../../../constants/Settings";
import { SpecialPayment } from "@/model/SpecialPayment";
import { datePickerLang } from "@/constants/globalConstants";
import PayGroupService from "@/service/PayGroupService";
import ArrayHelper from "../../../../common/helper/ArrayHelper";
import ImportFile from "@/components/FileReader";
import SpecialPaymentService from "../../../../service/SpecialPaymentService";
import SweetAlertService from "../../../../service/SweetAlertService";
import PayrollAdjustmentService from "../../../../service/PayrollAdjustmentService";
export default {
  name: "SpecPayApproval",
  components: {
    DatePicker,
    moment,
    ImportFile
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    disabledMode() {
      return this.selectMode == this.modelList.view;
    },
    IncTypeList() {
      const list = this.incTypeList;
      const Datas = ArrayHelper.uniqueBykey(list, "IncTypeDesc");
      return Datas;
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.PayrollApproval,
      Settings: Settings,
      dictEnum: dictEnum,
      lang: datePickerLang,
      specPayList: [],
      specPayField: [
        {
          key: "DateVal",
          label: t.t(dictEnum.LBL_Date)
        },
        {
          key: "PayDesc",
          label: t.t(dictEnum.LBL_Particular)
        },
        {
          key: "TotAmt",
          label: t.t(dictEnum.LBL_Amount)
        },
        {
          key: "Status",
          label: t.t(dictEnum.LBL_Status)
        }
      ],
      currentPage: 1,
      perPage: 15,
      selectMode: "",
      paymentStatus: "All",
      paymentStatusList: [
        {
          id: Settings.PayrollStatus.New,
          value: t.t(dictEnum.LBL_New)
        },
        {
          id: Settings.PayrollStatus.Approving,
          value: t.t(dictEnum.LBL_Pending)
        },
        {
          id: Settings.PayrollStatus.Approved,
          value: t.t(dictEnum.LBL_Approved)
        },
        {
          id: Settings.PayrollStatus.Released,
          value: t.t(dictEnum.LBL_Released)
        },
        {
          id: Settings.PayrollStatus.Closed,
          value: t.t(dictEnum.LBL_Closed)
        },
        {
          id: Settings.PayrollStatus.Rejected,
          value: t.t(dictEnum.LBL_Rejected)
        }
      ],
      modelList: {
        edit: "Edit",
        view: "View"
      },
      selectedItem: {},
      specPaymentDetail: [],
      messageShow: false,
      messageList: [],
      selectedMsg: {},
      datePay: moment().format(Settings.DateTime.yyyymmdd),
      incTypeList: [],
      selectedIncType: {},
      selectedIncSubType: {},
      selectedList: [],
      ApproveORReject: false,
      selectedDtl: {
        StaffID: "",
        Msg: ""
      }
    };
  },

  mounted() {
    this.assignRights();
    this.getPaymentList();
    this.getIncTypeList();
  },

  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];

      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },

    StatusName(statusId) {
      const status = this.paymentStatusList.find(x => x.id == statusId);
      if (status) {
        return status.value;
      }
    },

    TotalActual() {
      let num = 0;
      if (this.specPaymentDetail.length > 0) {
        this.specPaymentDetail.forEach(x => {
          num = num + this.Actual(x);
        });
      }
      return num;
    },

    Actual(item) {
      let num = 0;
      item.Details.forEach(x => {
        num = num + x.Total;
      });
      return num;
    },

    changeIncType() {
      this.selectedIncSubType = "";
    },

    initData() {
      this.selectMode = this.modelList.new;
      this.selectedItem = {};
      this.specPaymentDetail = [];
      this.selectedList = [];
    },

    async getPaymentList() {
      const obj = {
        status: this.paymentStatus
      };
      const response = await SpecialPaymentService.getSpecialPaymentList(obj);
      if (response.data.IsSuccess) {
        ArrayHelper.sortByKey(response.data.Data, "DateVal", false);
        this.specPayList = response.data.Data;
        this.initData();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getIncTypeList() {
      const obj = {};
      const response = await PayrollAdjustmentService.getIncTypeList(obj);
      if (response.data.IsSuccess) {
        this.incTypeList = response.data.Data.filter(x => x.MPF);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (
        item.TxNum == this.selectedItem.TxNum &&
        item.Status == this.selectedItem.Status
      ) {
        return "selected-tr";
      }
    },

    showAddSpecPayment() {
      this.$bvModal.show("SpecPaymentShow");
    },

    async addSpecialPayment() {
      this.selectedItem = {
        TxNum: "",
        CompCode: this.$store.getters[StoreGetter.serverRouter].CompCode,
        FiscalPer: moment(this.datePay).format("YYYY"),
        DateVal: moment(this.datePay).format("YYYY"),
        IncTypeCode: this.selectedIncType,
        IncSubType: this.selectedIncSubType
      };
      this.selectMode = this.modelList.edit;
    },

    editSpecialPayment() {
      this.selectMode = this.modelList.edit;
    },

    async deleteSpecialPayment() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_Delete)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          txNum: this.selectedItem.TxNum,
          Status: this.selectedItem.Status
        };
        const response = await SpecialPaymentService.deleteSpecialPayment(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.getPaymentList();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async clickSendSpecPayment() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.BTN_Submit)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          txNum: this.selectedItem.txNum,
          status: this.selectedItem.Status
        };
        const response = await SpecialPaymentService.sendSpecialPayment(obj);
        if (response.data.IsSuccess) {
          this.getPaymentList();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async ApprovelItems() {
      this.$bvModal.show("ApprovalORRejectModalList");
      this.ApproveORReject = true;
    },

    RejectlItems() {
      this.$bvModal.show("ApprovalORRejectModalList");
      this.ApproveORReject = false;
    },

    async clickExport() {
      // const obj = {
      //     txNum: this.selectedItem.TxNum
      // }
      // const response = await SpecialPaymentService.exportSpecialPayment(obj);
      // if (response.data.IsSuccess) {
      //     this.getPaymentList();
      //     SweetAlertService.success("Success", response.data.Message)
      // } else {
      //     SweetAlertService.warning("Warn", response.data.Message)
      // }
      // this.ExportTableData()
    },

    async ExportTableData() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ExportFile),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        let list = [],
          datas = [];
        for (const i in this.specPaymentDetail) {
          const data = this.specPaymentDetail[i];
          list = list.concat(data.Details);
        }
        list.forEach(x => {
          data.push({
            StaffID: x.Id,
            StaffName: x.Name,
            DateJoin: moment(x.DateJoin).format(Settings.DateTime.yyyymmdd),
            DateTx: moment(this.selectedItem.DateTx).format(
              Settings.DateTime.yyyymmdd
            ),
            Type: x.Type,
            Dept: x.Dept,
            Particular: this.selectedItem.Particular,
            IncType: this.selectedItem.IncTypeCode,
            IncSubType: this.selectedItem.IncSubType,
            Total: x.Total
          });
        });
        var XLSX = require("xlsx");
        var worksheet = XLSX.utils.json_to_sheet(data, false);
        let workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet);
        XLSX.writeFile(
          workbook,
          "SpecialPayment" +
            "_" +
            moment().format(Settings.DateTime.yyyymmddhhmmss) +
            ".xlsx"
        );
      }
    },

    async clickPrint() {
      const obj = {
        txNum: this.selectedItem.TxNum
      };
      const response = await SpecialPaymentService.printSpecialPayment(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.error("Error", response.data.Message);
      }
    },

    async OnSpecialPaymentSelect(item) {
      item.DateVal = moment(item.DateVal).format(Settings.DateTime.yyyymmdd);
      this.selectedItem = JSON.parse(JSON.stringify(item));
      const obj = {
        txNum: item.TxNum,
        status: item.Status
      };
      const response = await SpecialPaymentService.getSpecialPaymentDtl(obj);
      if (response.data.IsSuccess) {
        this.specPaymentDetail = response.data.Data;
        this.selectMode = this.modelList.view;
        this.selectedList = [];
        this.getPaymentMessage();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async clickSaveDtl() {
      let list = [],
        datas = [];
      this.specPaymentDetail.forEach(x => (list = list.concat(x.Details)));
      list.forEach(x => {
        datas.push({
          StaffID: x.Id,
          Amt: x.Total,
          Status: x.Status,
          PayDesc: this.selectedItem.PayDesc,
          IncSubType: this.selectedItem.IncSubType,
          IncTypeCode: this.selectedItem.IncTypeCode,
          DateVal: moment(this.selectedItem.DateVal).format(
            Settings.DateTime.yyyymmdd
          )
        });
      });
      const obj = {
        model: datas
      };
      const response = await SpecialPaymentService.saveSpecialPayment(obj);
      if (response.data.IsSuccess) {
        this.getPaymentList();
        this.OnSpecialPaymentSelect(this.selectedItem);
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    importData(value) {
      var XLSX = require("xlsx");
      const input = $("#fileReader");
      let reader = new FileReader();
      reader.readAsBinaryString(input[0].files[0]);
      reader.onload = async e => {
        let workbook = XLSX.read(e.target.result, { type: "binary" });
        let sheetList = workbook.SheetNames;
        let rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetList[0]], {
          defval: ""
        });
        rows = rows.map(obj => Object.values(obj));
      };
    },

    selectedAppr(item) {
      const find = this.selectedList.find(x => x.Id == item.Id);
      if (!find) {
        this.selectedList.push(item);
      } else {
        this.selectedList = this.selectedList.filter(x => x.Id != item.Id);
      }
    },

    showOnlyApp(dtl) {
      if (dtl.Status == Settings.PayrollStatus.Approving) {
        this.selectedDtl = dtl;
        this.$bvModal.show("onlyApproval");
      }
    },

    async ApproveOrReject(bol) {
      const obj = {
        staffID: [this.selectedDtl.Id],
        txNum: this.selectedItem.TxNum,
        Notes: this.selectedDtl.Msg,
        isApproval: bol ? 1 : 0
      };
      const response = await SpecialPaymentService.approveSpecialPayment(obj);
      if (response.data.IsSuccess) {
        this.$bvModal.hide("onlyApproval");
        this.getPaymentList();
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async ApprOnlyDtl() {
      if (!this.ApproveORReject && !this.selectedDtl.Msg) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Msg) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${
          this.ApproveORReject
            ? t.t(dictEnum.LBL_Approve)
            : t.t(dictEnum.LBL_Reject)
        }`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        let staffList = [];
        let list = [];
        this.specPaymentDetail.forEach(x => {
          list = list.concat(x.Details);
        });

        if (this.ApproveORReject) {
          staffList = list
            .filter(x => x.Status == Settings.PayrollStatus.Approving)
            .map(x => x.Id);
        } else {
          let rejectList = [];
          if (this.selectedList.length > 0) {
            rejectList = this.selectedList;
          } else {
            rejectList = list
              .filter(x => x.Status == Settings.PayrollStatus.Approving)
              .map(x => x.Id);
          }
          staffList = rejectList.map(x => x.Id);
        }
        const obj = {
          staffID: staffList,
          txNum: this.selectedItem.TxNum,
          Notes: this.selectedDtl.Msg,
          isApproval: this.ApproveORReject ? 1 : 0
        };
        const response = await SpecialPaymentService.approveSpecialPayment(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.getPaymentList();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async getPaymentMessage() {
      const obj = {
        txNum: this.selectedItem.TxNum
      };
      const response = await SpecialPaymentService.getSpecialPaymentMsg(obj);
      if (response.data.IsSuccess) {
        this.messageList = response.data.Data;
        this.selectedMsg = {};
        ArrayHelper.sortByKey(this.messageList, "DateAdd", false);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async showPaymentMessage() {
      this.$bvModal.show("messageShow");
      this.selectedMsg = this.messageList[0];
    },

    clickMsg(item) {
      this.selectedMsg = item;
    }
  }
};
</script>
<style scoped lang="scss">
.btn-message {
  background-color: #5ba7be;
}
.approve-tr {
  background: #d5ffd5;
}

.reject-tr {
  background: #ffa2a2;
}
.paymentByDept {
  &_head {
    background-color: #d3e2e7;

    div {
      padding: 5px;
      font-size: 14px;
      font-weight: bold;
    }
  }

  &_table {
    width: max-content;

    thead {
      background-color: #f5f5f5;

      th {
        min-width: 100px;
        color: black !important;
      }
    }

    tbody {
      background-color: white;
    }
  }
}

.popupTable {
  .head {
    background-color: #d3e2e7;

    th {
      color: black !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/100000-Payroll/104000-PayrollApproval/SpecPayApproval/SpecPayApproval.vue